import { Typography } from '@mui/material';
import { styled } from '@mui/system';
import { type FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useEffectOnce } from '../../../../../../../hooks/use-effect-once';
import { ConfigurationsContainer } from '../../../containers/ConfigurationsContainer';
import { useFetchPaddleSettings } from '../hooks/useFetchPaddleSettings';
import type {
  PaddleConfigurationControl,
  PaddleConfigurationFormValues,
} from '../PaddleConfigurationFormSchema';
import { InvoicesConfigurationSection } from './components/InvoicesConfigurationSection';
import { KeyConfigurationSection } from './components/KeyConfigurationSection';

type PaddleConfigurationFormProps = {
  control: PaddleConfigurationControl;
};

export const PaddleConfigurationForm: FC<PaddleConfigurationFormProps> = ({ control }) => {
  const { configuration } = useFetchPaddleSettings();
  const { reset } = useFormContext<PaddleConfigurationFormValues>();

  useEffectOnce(() => {
    reset(configuration);
  });

  return (
    <FormContainer>
      <Typography variant="h5">Configurations</Typography>
      <ConfigurationsContainer>
        <KeyConfigurationSection control={control} defaultValues={configuration} />
        <InvoicesConfigurationSection control={control} defaultValues={configuration} />
      </ConfigurationsContainer>
    </FormContainer>
  );
};

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});
